






import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

// 导入icons目录
const importAll = (requireContext: __WebpackModuleApi.RequireContext) => requireContext.keys().forEach(requireContext);
try {importAll(require.context('../assets/icons', true, /\.svg$/));} catch (error) {console.log(error);}
@Component
export default class Icon extends Vue {
    @Prop({required: true, type: String}) name!: string;
}
